import { render, staticRenderFns } from "./SchoolTerms.vue?vue&type=template&id=5680d000&"
import script from "./SchoolTerms.vue?vue&type=script&lang=ts&"
export * from "./SchoolTerms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports